import { StudentDetailsState } from '../initial.state';
import { studentManagementActions } from '../actions/studentManagement.actions';

function StudentManagementReducer(state = new StudentDetailsState(), action) {
  switch (action.type) {
    case studentManagementActions.STUDENT_LIST_SUCCESS:
      return {
        ...state,
        studentsList: action.payload.data?.content ?? [],
        studentsTotalElements: action.payload.data?.totalElements ?? 0,
      };
    case studentManagementActions.STUDENT_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        studentDetails: action.payload.data,
      };
    case studentManagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptionsList: action.payload.data,
      };
    case studentManagementActions.STUDENT_ADDONS_SUCCESS:
      return {
        ...state,
        addonsList: action.payload.data,
      };
    case studentManagementActions.STUDENT_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesList: action.payload.data,
      };
    case studentManagementActions.STUDENT_EMAIL_VERIFY_SUCCESS:
      return {
        ...state,
        emailVerified: true,
      };
    default:
      return {
        ...state,
      };
  }
}

export { StudentManagementReducer };
